var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",class:_vm.type},[_c('div',{ref:"modal",staticClass:"modal__container animated fadeIn",style:({
                  'background': _vm.bg,
                  '--height': _vm.height,
                  '--width': _vm.width,
                  '--padding':_vm.padding
           })},[_c('div',{staticClass:"m-header"},[_vm._t("mHeader"),_c('div',{staticClass:"close-modal",on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ez-icon-clear"})])],2),_c('div',{staticClass:"m-body"},[_vm._t("mBody")],2),(_vm.footerVisible)?_c('div',{staticClass:"m-footer"},[_vm._t("mFooter")],2):_vm._e(),(_vm.secondFooter)?_c('div',{staticClass:"m-second-footer"},[_vm._t("mSecondFooter")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }